import React, { useState } from "react";
import { Typography, CircularProgress, Button } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import TurnosMetaTemplateBlock from "../TurnosMetaTemplateBlock";

// ─────────────────────────────────────────────────────────────────────────────
// Editor de OVERRIDE manual mensaje→plantilla Meta (superadmin). Lista por kind,
// cada uno con selector + preview con fichas (TurnosMetaTemplateBlock). Toggle
// local "Ver con datos de ejemplo". En admin (Ajustes) los bloques se renderizan
// DENTRO de cada mensaje interno (no se usa este wrapper).
//
// props:
//   kinds:    [{ kind, label, defaultName, varCount, varOrder, override }]
//   approved: { applicable, reason, templates, canonical }
//   saving:   { [kind]: bool }
//   onSave(kind, { templateName|null, variableCount|null })
// ─────────────────────────────────────────────────────────────────────────────
const TurnosTemplateOverrides = ({ kinds = [], approved, saving = {}, onSave }) => {
  const [showExample, setShowExample] = useState(false);

  if (!approved) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <CircularProgress size={16} />{" "}
        <Typography variant="caption">{i18n.t("templateOverrides.loading")}</Typography>
      </div>
    );
  }

  if (!approved.applicable) {
    return (
      <Typography variant="body2" color="textSecondary">
        {approved.reason === "qr_line"
          ? i18n.t("templateOverrides.qrLine")
          : i18n.t("templateOverrides.noLine")}
      </Typography>
    );
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
        <Typography variant="caption" color="textSecondary">
          {i18n.t("templateOverrides.intro")}
        </Typography>
        <Button size="small" variant="outlined" onClick={() => setShowExample((v) => !v)}>
          {showExample ? i18n.t("templateOverrides.hideExample") : i18n.t("templateOverrides.showExample")}
        </Button>
      </div>

      {kinds.map((k) => (
        <div key={k.kind} style={{ padding: "8px 0", borderBottom: "1px solid #f0f0f0" }}>
          <Typography variant="subtitle2" style={{ fontWeight: 600 }}>{k.label}</Typography>
          <TurnosMetaTemplateBlock
            kindData={k}
            approved={approved}
            showExample={showExample}
            saving={!!saving[k.kind]}
            onSave={onSave}
          />
        </div>
      ))}
    </div>
  );
};

export default TurnosTemplateOverrides;
